export const NUMBER_OF_EVENTS = 8000
